import { CSSProperties } from "react";
import classNames from "classnames";
import Button from "react-bootstrap/Button";
import styles from "./axnui-theming-confirm-button.less";

type AXNUIThemingConfirmButtonProps = {
    id: string;
    className: string;
    color?: "inherit" | "primary" | "secondary" | "default";
    size: "sm" | "lg";
    height?: any;
    width?: any;
    cornerRadius?: any;
    backgroundColor?: string;
    textColor?: string;
    buttonText?: string;
    borderWidth?: string;
    borderColor?: string
};

export const AXNUIThemingConfirmButton = (props: AXNUIThemingConfirmButtonProps) => {
    const {
        id,
        className,
        color,
        size,
        height,
        width,
        cornerRadius,
        backgroundColor,
        textColor,
        buttonText,
        borderWidth,
        borderColor
    } = props;

    const buttonStyle: CSSProperties = {
        height,
        width,
        borderRadius: cornerRadius,
        backgroundColor: backgroundColor || undefined,
        color: textColor || undefined,
        borderWidth,
        borderColor: borderColor || "transparent"
    };

    return (
        <Button
            id={id}
            color={color}
            size={size}
            className={classNames(styles.confirmButton, className)}
            style={buttonStyle}
        >
            <span>{buttonText}</span>
        </Button>
    );
};